import type { CampaignWeek } from '@/models/campaign-week'
import type { MealProgramSubscriptionWeek } from '@/models/meal-program-subscription-week'
import type MealSwap from '@/models/meal-swap'
import type { SubscriptionWeekMenu } from '@/models/subscription-week-menu'
import type { UiValidationsForWeek } from '@/types/pops'
import dayjs, { type Dayjs } from '@/utilities/dayjs-config'

import {
  $allowedChangesForWeeks,
  $campaignWeeks,
  $mealSwaps,
  $subscriptionWeeks,
  $subscriptionWeeksMenus,
} from './stores'

export const setSubscriptionWeek = ({
  week,
  subscriptionWeek,
}: {
  week: string
  subscriptionWeek: MealProgramSubscriptionWeek
}) => {
  const weekString = dayjs(week).startOf('week').format('YYYY-MM-DD')
  $subscriptionWeeks.setKey(weekString, subscriptionWeek)
}

export const setSubscriptionWeekMenu = ({
  week,
  menu,
}: {
  week: string
  menu: SubscriptionWeekMenu
}) => {
  const weekString = dayjs(week).startOf('week').format('YYYY-MM-DD')
  $subscriptionWeeksMenus.setKey(weekString, menu)
}

export const setCampaignWeek = ({
  week,
  campaignWeek,
}: {
  week: string
  campaignWeek: CampaignWeek
}) => {
  const weekString = dayjs(week).startOf('week').format('YYYY-MM-DD')
  $campaignWeeks.setKey(weekString, campaignWeek)
}

export const setWeekMealSwaps = ({
  week,
  mealSwaps,
}: {
  week: Dayjs
  mealSwaps: MealSwap[]
}) => {
  const weekString = dayjs(week).startOf('week').format('YYYY-MM-DD')
  $mealSwaps.setKey(weekString, mealSwaps)
}

export const setAllowedChangesForWeek = ({
  week,
  allowedChanges,
}: {
  week: string
  allowedChanges: UiValidationsForWeek
}) => {
  const weekString = dayjs(week).startOf('week').format('YYYY-MM-DD')
  $allowedChangesForWeeks.setKey(weekString, allowedChanges)
}
